import React from 'react';
import {useLocation} from 'react-router-dom';

export const useQuery = (): { [key: string]: string } => {
    const {search} = useLocation();

    return React.useMemo(() => Array.from(new URLSearchParams(search).entries())
        .reduce((params, entry) => ({...params, [entry[0]]: entry[1]}), {}), [search]);
};
